import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Skeleton } from '@/components/ui/FeedBack/Skeleton';
import { hotlineDescriptionListStyle } from '@/feature/hotline/component/HotlineDescriptionList/style';
import { useArrayWithIndex } from '@/hooks/array/useArrayWithIndex';
/**
 * 匿名ホットライン 詳細説明コンポーネント
 */
export const HotlineDescriptionListSkeleton = (props) => {
    const { className = '', itemCount = 7 } = props;
    const dummies = useArrayWithIndex(itemCount);
    const style = hotlineDescriptionListStyle();
    return (_jsx("div", Object.assign({ className: style.base({ class: className }) }, { children: dummies.map(({ index: key }) => (_jsxs("div", Object.assign({ className: style.item() }, { children: [_jsx("div", Object.assign({ className: style.itemTitle() }, { children: _jsx(Skeleton, { className: 'w-[100px] h-[20px]' }) })), _jsx("div", Object.assign({ className: style.itemValue() }, { children: _jsx(Skeleton, { className: 'w-full h-[20px]' }) }))] }), `HotlineDescriptionList_${key}`))) })));
};
